import { render, staticRenderFns } from "./local_attr.vue?vue&type=template&id=2c397a64"
import script from "./local_attr.vue?vue&type=script&lang=js"
export * from "./local_attr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports